module.exports = __webpack_public_path__ + "static/media/Poppins-Bold-latin.25b0e113.woff2";